import { render, staticRenderFns } from "./UserClaimsDetails.vue?vue&type=template&id=118266cc&scoped=true&"
import script from "./UserClaimsDetails.vue?vue&type=script&lang=js&"
export * from "./UserClaimsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118266cc",
  null
  
)

export default component.exports